import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function TimetablePage() {
  return <InstituteCrudPage config={entityConfigs['timetables']} />;
}
